<template>
  <div class="jd-navigator">
    <el-image class="ask-icon" :src="imgUrl" style="width:1000px"></el-image>
    <!-- <div @click="jtjunk('行业专区预览页/顶部/升级高级版')" class="top_btn">顶部立即升级高级版</div>
    <div @click="jtjunk('行业专区预览页/运营策略/升级高级版')" class="strategy_btn">运营策略立即升级高级版</div>
    <div @click="jtjunk('行业专区预览页/行业人群/升级高级版')" class="crowd_btn">行业人群立即升级高级版</div>
    <div @click="jtjunk('行业专区预览页/底部/升级高级版')" class="bottom_btn">立即升级</div> -->
  </div>
</template>

<script>
import functionCompare from "./function-compare";
export default {
  name: "jdNavigator",
  components: {
    functionCompare
  },
  data() {
    return {
      imgUrl: require("@/assets/images/heightVersion/shop/permission-preview.jpg"),
      show1: true
    };
  },
  mounted(){
    // 页面埋点
    this.buriedPoint(1, "行业专区预览页", "行业专区", "行业专区预览页");
  },
  methods: {
    jtjunk(str) {
      this.buriedPoint(2, str);
      const href = "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch";
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang='scss' scoped>
.jd-navigator {
  margin: 0 auto;
  width: 1000px;
  position: relative;
  .top_btn {
    opacity: 0;
    position: absolute;
    top: 275px;
    left: 65px;
    width: 200px;
    height: 44px;
    cursor: pointer;
    border-radius: 30px;
  }
  .strategy_btn {
    opacity: 0;
    position: absolute;
    top: 2080px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 44px;
    cursor: pointer;
    border-radius: 30px;
  }
  .crowd_btn {
    opacity: 0;
    position: absolute;
    top: 3726px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 44px;
    cursor: pointer;
    border-radius: 30px;
  }
  .bottom_btn {
    opacity: 0;
    position: absolute;
    bottom: 200px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 226px;
    height: 62px;
    cursor: pointer;
    border-radius: 30px;
  }
}
</style>
